import React from 'react';
import clsx from 'clsx';
import greenTick from '../../../../../../../assets/green-tick.svg';
import { alertIcon } from '../../../../../../../assets/hostedassets';
import PotentialRiskRedirectIcon from '../../../../../../RiskIndicators/PotentialRiskRedirectIcon';
import profileStyles from './UserProfile.module.scss';
import tabStyles from '../../../../ManagementProfileTab/ManagementProfileTab.module.scss';
import type { RegulatoryCountRowProps } from './ManagementUserProfile.types';
import { getCountRowStatus } from './managementUserProfileUtils';
import DrawerRow from './DrawerRow';
import ClickableValue from './ClickableValue';
import { NotConfiguredLabel } from '../../../../ManagementProfileTab/CheckStatusLabels';
import { NOT_CONFIGURED_TOOLTIP } from '../../../../ManagementProfileTab/ManagementProfileTabConstants';

const RegulatoryCountRow = ({
    label,
    count,
    locked,
    notReady,
    unitSingular,
    unitPlural,
    zeroLabel,
    onClickIfPositive,
    isPDFReport,
    mutedLabel,
    lockedTooltip,
    badge,
    notConfigured,
    tooltip,
}: RegulatoryCountRowProps) => {
    if (notConfigured) {
        return (
            <DrawerRow
                label={label}
                mutedLabel={mutedLabel}
                valueOwnsStyling
                title={NOT_CONFIGURED_TOOLTIP}
                value={<NotConfiguredLabel />}
            />
        );
    }
    const status = getCountRowStatus(count, { locked, notReady, unitSingular, unitPlural, zeroLabel });
    /*
        RECUR-27829. When a badge is supplied (Regulatory Checks only) the row reports its
        verdict — "2 Confirmed" in the table's confirmed colour — instead of a bare tally. The
        dash and zero states still come from `status`, so "never screened" and "screened, clean"
        keep behaving as they do for every other row.
    */
    const useBadge = !!badge && status.kind === 'alert';
    const clickable = status.kind === 'alert' && !isPDFReport && !!onClickIfPositive;
    return (
        <DrawerRow
            label={label}
            mutedLabel={mutedLabel}
            valueOwnsStyling
            // Only a locked module gets a hint; "absent" and "not ready" are just
            // no-data-yet and don't need explaining.
            title={status.kind === 'dash' ? (locked ? lockedTooltip : undefined) : tooltip}
            value={
                status.kind === 'dash' ? undefined : (
                    <ClickableValue
                        clickable={clickable}
                        onClick={onClickIfPositive}
                        className={clsx(profileStyles.CountValue, { [tabStyles.alertClickable]: clickable })}
                    >
                        <span
                            className={
                                useBadge ? tabStyles.alertBadge : status.kind === 'positive' ? tabStyles.alertGrey : tabStyles.alertRed
                            }
                            style={useBadge ? { color: badge!.color } : undefined}
                        >
                            {!isPDFReport &&
                                (useBadge ? (
                                    <PotentialRiskRedirectIcon className={profileStyles.CountIcon} color={badge!.color} />
                                ) : (
                                    <img
                                        src={status.kind === 'positive' ? greenTick : alertIcon}
                                        alt={''}
                                        className={profileStyles.CountIcon}
                                    />
                                ))}
                            {useBadge ? `${badge!.count} ${badge!.label}` : status.label}
                        </span>
                    </ClickableValue>
                )
            }
        />
    );
};

export default RegulatoryCountRow;
